package top.wcpe.allincore.ui.runtime.internal.collections

/** JS：普通拷贝——单线程且无 Java 可变视图问题，Kotlin 只读接口已足够。 */
internal actual fun <T> readOnlyCopy(list: List<T>): List<T> = list.toList()

/** JS：普通拷贝（保插入序）。 */
internal actual fun <K, V> readOnlyCopy(map: Map<K, V>): Map<K, V> = map.toMap()
